import { useState } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import MyButton from "../../Components/MyButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";

function Categories() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleAdd = () => {
    setFormData({
      name: "",
      description: "",
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
  };

  const handleEdit = (record) => {
    setFormData({ ...record });
    setEditId(record.uuid);
    setErrors({});
    setShowModal(true);
  };

  const handleDeleteClick = (uuid) => {
    setDeleteId(uuid);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/categories/${deleteId}`);
      console.log("تم حذف التصنيف بنجاح");
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error(err);
      toast.error("فشل الحذف");
    } finally {
      setDeleting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      if (editId) {
        await API.put(`/categories/${editId}`, formData);
        console.log("تم تعديل التصنيف بنجاح");
      } else {
        await API.post("/categories", formData);
        console.log("تم إضافة التصنيف بنجاح");
      }
      setShowModal(false);
      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { header: "الاسم", accessor: "name" },
    { header: "الوصف", accessor: "description" },
    {
      header: "الإجراءات",
      accessor: (row) => (
        <>
          <Can permission="category_update">
            <button
              className="btn btn-sm btn-primary mx-1 no-style"
              onClick={() => handleEdit(row)}>
              <FontAwesomeIcon icon={faPen} />
            </button>
          </Can>
          <Can permission="category_delete">
            <button
              className="btn btn-sm btn-danger no-style"
              onClick={() => handleDeleteClick(row.uuid)}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </Can>
        </>
      ),
      hideOnPrint: true 
    },
  ];

  return (
    <div className="container mt-5">
      <Mytitle title="التصنيفات" />

      {/* <Can permission="category_create">

                <MyButton
                    text="إضافة تصنيف"
                    variant="success"
                    type="button"
                    className="mb-3"
                    onClick={handleAdd}
                />
            </Can> */}

      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title={editId ? "تعديل التصنيف" : "إضافة تصنيف"}
        onSubmit={handleSubmit}
        loading={loading}
        mode="form">
        <MyInput
          label="الاسم"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          error={errors.name?.[0]}
        />
        <MyInput
          label="الوصف"
          value={formData.description}
          onChange={(e) =>
            setFormData({ ...formData, description: e.target.value })
          }
          error={errors.description?.[0]}
        />
      </ModalForm>

      <ModalForm
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="تأكيد الحذف"
        onSubmit={confirmDelete}
        loading={deleting}
        mode="confirm"
        confirmText="حذف"
        cancelText="إلغاء">
        هل أنت متأكد أنك تريد حذف هذا التصنيف؟
      </ModalForm>

      <MyTable
        resource="categories"
        columns={columns}
        refreshKey={refreshKey}
        title= "التصنيفات"
        button={{
          text: "إضافة تصنيف",
          onClick: handleAdd,
          variant: "success",
          permission: "category_create",
        }}
      />
    </div>
  );
}

export default Categories;
